import Input from 'antd/es/input';
import CreateAntField from './CreateAntField';

export default CreateAntField(Input.Password);
